<template>
  <div>
    <div class="content-item flex">
      <p class="content-item-label"><span class="red">*</span>是否允许分享</p>
      <el-radio-group
        v-model="canShare"
        class="flex align-items-center"
        style="margin-left: 10px"
        @change="canShareHandle"
      >
        <el-radio :label="false">不允许</el-radio>
        <el-radio :label="true">允许</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
// 写手端：user, 运营端: man, 超管端：admin
import {
  queryContentRiskControl,
  healthCmpBizPageDuplicateRecord,
} from "@/api/man";
import pagination from "../pagination";
var app_type = process.env.VUE_APP_TYPE;
export default {
  name: "articleSource",
  props: ["canShare", "canShareHandle"],
  data() {
    return {};
  },
  created() {
    if (this.canShare == undefined) {
      this.canShare = true;
    }
  },
  // methods: {
  //   // 获取最终判断
  //   onChange(val) {
  //     alert(333)
  //     // this.canShareHandle(val)
  //     console.log(22222, val)
  //     // this.$emit("canShareHandle", val);
  //   },

  // },
};
</script>

<style lang="scss" scoped>
// 查重 ----------------------------
.content-item {
  .item-table {
    width: 902px;
  }
  .original-styles {
    margin-left: 15px;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      display: block;
      margin-right: 10px;
      width: 2px;
      height: 15px;
      background-color: #606266;
    }
    span.black {
      color: #606266 !important;
    }
    .el-button {
      margin-left: 10px;
      padding: 10px;
      > span {
        margin: 0;
        line-height: 19.2px;
      }
      .button {
        margin: 0;
      }
    }
  }
}
.red {
  color: red;
}
.article .wrap .content-item :deep(.el-pagination__jump .el-input) {
  width: 50px;
}
.article .wrap .content-item :deep(.el-pagination__sizes .el-select .el-input) {
  width: 100px;
}
// 查重 ----------------------------
</style>
